import store from '../../../global-state/redux';
import { vmTreeGet } from '../../vmTree';

const { getState } = store;

export const getStoreByPath = (vmPath) => vmTreeGet(getState(), vmPath);
